import React, { useEffect } from 'react'
import MaskedTextInput from 'components/MaskedTextInput';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';


function PostCodeRow({
	defaultValue,
	formikProps,
	limits,
	required,
	prefix
}) {
	const postCodeId = `postCode`
	const postCodeValue = formikProps.values.postCode;

	useEffect(() => {
		if (prefix === defaultValue) {
			if (postCodeValue.includes('-')) {
				const newValue = postCodeValue.slice(0,6)
				formikProps.setFieldValue(postCodeId, newValue)
			} else {
				const FirstPart = postCodeValue.substr(0, 2)
				const SecondPart = postCodeValue.substr(2, 3)

				if (postCodeValue.length > 0) {
					formikProps.setFieldValue(postCodeId, `${FirstPart}-${SecondPart}`)
				}
			}
		}
		//eslint-disable-next-line
	}, [prefix])

	return prefix === defaultValue ?
		<MaskedTextInput
			id='postCode'
			formikProps={formikProps}
			mask="99-999"
		>
			<TextInput
				id='postCode'
				label={Tr('zip_code')}
				formikProps={formikProps}
				required={required}
			/>
		</MaskedTextInput>
		:
		<TextInput
			id='postCode'
			label={Tr('zip_code')}
			formikProps={formikProps}
			required={required}
			limit={limits.POSTCODE}
		/>
}

export default PostCodeRow